import { Injectable } from "@angular/core";
// BFX
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import {
  StaticDataPrivatizationType,
  ClientAccountVisibilityType,
  AccountPromiseLookupService,
  AccountLookupService,
  ClientPromiseLookupService,
  ClientLookupService,
} from "shared/cubiq-services";
import { ICAutocompleteAccountModel } from "../../interface/controls/models/bfx-interface-controls.models";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OEAccountMediatorService {
  private accountLookupService: AccountLookupService;
  private clientLookupService: ClientLookupService;

  /**********************************************************************/
  /* DATA  */

  /**********************************************************************/
  /* CONSTRUCTOR  */
  constructor(
    private accountPromiseLookup: AccountPromiseLookupService,
    private clientPromiseLookup: ClientPromiseLookupService,
  ) {
    this.accountLookupService = accountPromiseLookup.getBase();
    this.clientLookupService = clientPromiseLookup.getBase();
  }

  /**********************************************************************/
  /* Public API  */
  public processClient(client: string | CubiqTS.ClientImpl): void {
    // Deprecated API
  }

  public getAccountsForClient(
    client: string | CubiqTS.ClientImpl,
    transformed: boolean = false,
    onlyFullVisibility: boolean = false,
  ): Promise<Array<CubiqTS.AccountImpl | ICAutocompleteAccountModel>> {
    return new Promise<Array<CubiqTS.AccountImpl | ICAutocompleteAccountModel>>((res, rej) => {
      if (client != null) {
        let clientId = typeof client === "string" ? client : client.clientId;

        if (typeof client == "string") {
          client = this.clientLookupService.getClient(client);
        }

        let clientSalesGroup: string = client.salesGroupId.toString();
        this.accountPromiseLookup
          .getActiveBreakAndClientAccounts(clientId, clientSalesGroup, onlyFullVisibility)
          .then((accounts: CubiqTS.AccountImpl[]) => {
            if (transformed) {
              res(this.accountTransformResults(accounts));
            } else {
              res(accounts);
            }
          });
      } else {
        res(null);
      }
    });
  }

  /* Same as getAccount but avoids searching the entire cache when client is known */
  public getAccountOfClient(
    accountId: string,
    client: string | CubiqTS.ClientImpl,
  ): Promise<CubiqTS.AccountImpl> {
    return new Promise<CubiqTS.AccountImpl>((res, rej) => {
      if (accountId != null && client != null) {
        res(this.accountLookupService.getAccount(accountId));
      } else {
        res(null);
      }
    });
  }

  protected accountTransformResults(
    data: Array<CubiqTS.AccountImpl>,
  ): Array<ICAutocompleteAccountModel> {
    let result = Array<ICAutocompleteAccountModel>();
    for (let itemAccountImpl of data) {
      try {
        let item = this.accountTransformResult(itemAccountImpl);
        result.push(item);
      } catch (ex) {
        logger.out.error("EXCEPTION: _oeMediator.accountTransformResults(): ", ex);
      }
    }
    return result;
  }

  private accountTransformResult(itemAccountImpl: CubiqTS.AccountImpl): ICAutocompleteAccountModel {
    if (itemAccountImpl != null && itemAccountImpl instanceof CubiqTS.AccountImpl) {
      let item = new ICAutocompleteAccountModel(); // value => id
      item.id = itemAccountImpl.id;
      item.name = itemAccountImpl.name;
      item.bookingCode = itemAccountImpl.bookingCode;
      item.contact = itemAccountImpl.contact;
      //
      item.value = itemAccountImpl.id;
      item.label = item.id; //(item[this.data.tabActive.tab] != null && typeof item[this.data.tabActive.tab] === 'string' && item[this.data.tabActive.tab].length > 0)? item[this.data.tabActive.tab]: 'id: ' +  item.id;
      item.hasPrivatization = StaticDataPrivatizationType.hasPrivatization(itemAccountImpl);
      item.hasFullVisibility = ClientAccountVisibilityType.isFull(itemAccountImpl);
      return item;
    } else {
      throw "Can not transform, Item is null or wrong type (AccountImpl)!";
    }
  }

  public accountUpdateLabel(
    accounts: Array<ICAutocompleteAccountModel>,
    activeTab: string,
  ): Array<ICAutocompleteAccountModel> {
    let result = Array<ICAutocompleteAccountModel>();
    for (let account of accounts) {
      try {
        account.label =
          account[activeTab] != null &&
          typeof account[activeTab] === "string" &&
          account[activeTab].length > 0
            ? account[activeTab]
            : "id: " + account.id;
        result.push(account);
      } catch (ex) {
        logger.out.error("EXCEPTION: _oeMediator.accountUpdateLabel(): ", ex);
      }
    }
    return result;
  }
}
